import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Repository} from '@app/@core/repositories/repository';
import {CourseModel} from '@app/@core/domain/course.model';
import {environment} from '@env/environment';
import {map} from 'rxjs/operators';
import {orderBy} from 'lodash-es';
import {CourseTransferInfo} from '@app/modules/reserve/transfer/transfer.service';
import Course = CourseModel.Course;
import CourseStatus = CourseModel.CourseStatus;
import Transfer = CourseModel.Transfer;
import CourseImage = CourseModel.CourseImage;

export interface CourseOption {
    label: string;
    value: string;
    status: CourseStatus;
}

@Injectable({
    providedIn: 'root'
})
export class CourseRepository extends Repository<Course> {

    constructor(http: HttpClient) {
        super(http, 'course');
    }

    getAll(): Observable<CourseModel.Course[]> {
        return super.getAll().pipe(
            map(list => orderBy((list), 'name'))
        );
    }

    search(status: CourseStatus | string = ''): Observable<Course[]> {
        const params = {status};
        return this.http.get<Course[]>(`${this.entityUrl}/search`, {params}).pipe(
            this.mapList(),
            this.sortBy('name')
        );
    }

    fetchNames(): Observable<CourseOption[]> {
        return this.http.get<any[]>(`${this.entityUrl}/list/name`).pipe(
            map(list => list.map(m => ({
                value: m.id,
                label: m.name,
                status: m.status
            }))),
            map(list => orderBy((list), 'label'))
        );
    }

    updateTransfer(id: string, transfer: Transfer): Observable<Transfer> {
        return this.http.put<any>(`${environment.apiUrl}/api/${this.entity}/${id}/transfer`, transfer);
    }

    sendLineMessage(courseId: string, msg: string): Observable<Transfer> {
        return this.http.post<any>(`${environment.apiUrl}/api/${this.entity}/${courseId}/lineMessage`, {msg});
    }

    fetchBankCode(): Observable<{ name: string, code: string, label: string }[]> {
        return this.http.get<any[]>('assets/json/bank-code.json');
    }

    reloadCourse(): Observable<void> {
        return this.http.delete<void>(`${this.entityUrl}/cache/course`);
    }

    reloadCover(): Observable<void> {
        return this.http.delete<void>(`${this.entityUrl}/cache/cover`);
    }

    getTransferInfos(courseIds: string[]): Observable<CourseTransferInfo[]> {
        return this.http.post<any[]>(`${this.entityUrl}/transferInfos`, courseIds);
    }

    saveTransferNote(courseId: string, note: string): Observable<void> {
        return this.http.post<void>(`${this.entityUrl}/${courseId}/transferNote`, note);
    }

    saveImages(courseId: string, images: CourseImage[]): Observable<Course> {
        return this.http.post<Course>(`${this.entityUrl}/${courseId}/course-image/update`, images);
    }
}


